// import React, { useState, useEffect } from "react";
// import { motion, AnimatePresence } from "framer-motion";

// const testimonials = [
//   {
//     name: "John Doe",
//     designation: "CEO, Acme Corp",
//     feedback: "The level of legal precision at Nyaysakti is unmatched. They don't just provide advice; they provide a strategic shield for your business interests.",
//   },
//   {
//     name: "Jane Smith",
//     designation: "Founder, Tech Solutions",
//     feedback: "In legal matters, trust is everything. Their counsel has been my most valuable asset through years of complex corporate growth.",
//   },
//   {
//     name: "Michael Lee",
//     designation: "Entrepreneur",
//     feedback: "A masterclass in courtroom strategy. Their transparency and command over the law gave me confidence when I needed it most.",
//   },
// ];

// const TestimonialSlider = () => {
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const brandGold = "#E3B66B";
//   const darkGreen = "#0A1D1B";

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentIndex((prev) => (prev + 1) % testimonials.length);
//     }, 6000);
//     return () => clearInterval(interval);
//   }, []);

//   return (
//     <section className="bg-white py-24 px-6 md:px-12 relative overflow-hidden font-serif">
      
//       {/* Decorative Background Element */}
//       <div className="absolute top-0 right-0 w-1/3 h-full bg-[#FAF9F6] -z-0 hidden lg:block"></div>

//       <div className="max-w-7xl mx-auto grid lg:grid-cols-12 gap-16 items-center relative z-10">
        
//         {/* LEFT SIDE: Text & Navigation (5 Columns) */}
//         <div className="lg:col-span-5">
//           <div className="flex items-center gap-4 mb-8">
//             <div className={`w-12 h-[2px]`} style={{ backgroundColor: brandGold }}></div>
//             <span style={{ color: brandGold }} className="uppercase tracking-[0.5em] text-[10px] font-bold">
//               Client Testimonials
//             </span>
//           </div>
          
//           <h2 style={{ color: darkGreen }} className="text-5xl md:text-7xl font-bold leading-[1.1] mb-8">
//             Patrons <br />
//             <span className="italic font-light opacity-40">Voices</span>
//           </h2>
          
//           <p className="text-gray-500 font-sans text-lg leading-relaxed max-w-sm mb-16">
//             Our reputation is forged in the success of those we represent. 
//             Legacy is built on trust and absolute legal mastery.
//           </p>

//           {/* Luxury Custom Navigation */}
//           <div className="space-y-8">
//             {testimonials.map((t, i) => (
//               <button 
//                 key={i}
//                 onClick={() => setCurrentIndex(i)}
//                 className="flex items-center gap-6 group transition-all duration-500"
//               >
//                 <span className={`text-sm transition-all duration-500 ${currentIndex === i ? 'font-bold scale-125' : 'text-gray-300'}`}
//                       style={{ color: currentIndex === i ? darkGreen : '' }}>
//                   0{i + 1}
//                 </span>
//                 <div className="relative h-[1px] bg-gray-100 w-12 overflow-hidden">
//                   <motion.div 
//                     initial={false}
//                     animate={{ x: currentIndex === i ? 0 : -50 }}
//                     className="absolute inset-0 w-full"
//                     style={{ backgroundColor: brandGold }}
//                   />
//                 </div>
//                 <span className={`uppercase tracking-[0.3em] text-[10px] transition-all duration-500 ${currentIndex === i ? 'opacity-100 translate-x-2' : 'opacity-30'}`}
//                       style={{ color: darkGreen }}>
//                   {t.name}
//                 </span>
//               </button>
//             ))}
//           </div>
//         </div>

//         {/* RIGHT SIDE: The "Majestic" Card (7 Columns) */}
//         <div className="lg:col-span-7 relative h-[550px] flex items-center">
          
//           {/* Static Background Frames for Depth */}
//           <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[90%] h-[80%] border border-gray-100 -rotate-3 transition-transform duration-1000"></div>
//           <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[90%] h-[80%] border -rotate-6 hidden md:block" style={{ borderColor: `${brandGold}20` }}></div>

//           <AnimatePresence mode="wait">
//             <motion.div
//               key={currentIndex}
//               initial={{ opacity: 0, x: 50 }}
//               animate={{ opacity: 1, x: 0 }}
//               exit={{ opacity: 0, x: -50 }}
//               transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
//               style={{ backgroundColor: darkGreen }}
//               className="relative w-full p-12 md:p-20 shadow-[40px_40px_90px_rgba(0,0,0,0.2)]"
//             >
//               {/* Gold Ornament Detail */}
//               <div className="absolute top-0 left-0 w-2 h-full" style={{ backgroundColor: brandGold }}></div>
//               <div className="absolute top-10 right-10 text-[8rem] font-serif leading-none opacity-5 select-none" style={{ color: brandGold }}>
//                 “
//               </div>

//               <div className="relative z-10">
//                 <p className="text-white text-2xl md:text-3xl font-serif italic leading-relaxed mb-12">
//                   "{testimonials[currentIndex].feedback}"
//                 </p>

//                 <div className="flex flex-col gap-2">
//                   <div className="w-12 h-[2px]" style={{ backgroundColor: brandGold }}></div>
//                   <h4 style={{ color: brandGold }} className="text-xl font-bold uppercase tracking-widest mt-4">
//                     {testimonials[currentIndex].name}
//                   </h4>
//                   <p className="text-gray-400 text-xs uppercase tracking-[0.4em] font-sans">
//                     {testimonials[currentIndex].designation}
//                   </p>
//                 </div>
//               </div>

//               {/* Decorative Corner Square */}
//               <div className="absolute bottom-0 right-0 w-16 h-16 opacity-10" 
//                    style={{ borderRight: `1px solid ${brandGold}`, borderBottom: `1px solid ${brandGold}` }}>
//               </div>
//             </motion.div>
//           </AnimatePresence>
//         </div>
//       </div>

//       {/* Subtle Bottom Watermark */}
//       <div className="absolute bottom-10 right-10 opacity-[0.02] text-6xl font-black uppercase tracking-tighter" style={{ color: darkGreen }}>
//         Nyaysakti Chambers
//       </div>
//     </section>
//   );
// };

// export default TestimonialSlider;

import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const testimonials = [
  {
    name: "Rahul Sharma",
    role: "MD, Sharma Enterprises",
    feedback:
      "Adv. Akash Giri ki approach bilkul clear aur result-oriented hai.",
  },
  {
    name: "Anjali Gupta",
    role: "Entrepreneur",
    feedback:
      "Legal matters mein trust sabse badi cheez hoti hai.",
  },
  {
    name: "Vikram Singh",
    role: "Real Estate Consultant",
    feedback:
      "Courtroom strategy ho ya legal drafting, unmatched expertise.",
  },
  {
    name: "Neha Verma",
    role: "Startup Founder",
    feedback:
      "Documentation aur agreements perfectly structured the.",
  },
  {
    name: "Amit Kapoor",
    role: "Business Owner",
    feedback:
      "Full support from start to final judgement.",
  },
];

export default function TestimonialSection() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % testimonials.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const visible = testimonials
    .slice(current, current + 4)
    .concat(
      testimonials.slice(0, Math.max(0, current + 4 - testimonials.length))
    );

  return (
    <section className="bg-black text-white py-24 px-6 overflow-hidden">
      <div className="max-w-7xl mx-auto text-center">
        <h2 className="text-4xl md:text-6xl font-bold mb-10">
          What Our <span className="text-[#C5A059]">Clients Say</span>
        </h2>

        <div className="relative h-[380px] flex items-center justify-center overflow-hidden">
          <AnimatePresence initial={false}>
            {visible.map((t, index) => {
              const positions = [
                { x: -450, scale: 0.8, opacity: 0.2, z: 0 },
                { x: -220, scale: 0.9, opacity: 0.5, z: 1 },
                { x: 0, scale: 1, opacity: 1, z: 3 },
                { x: 220, scale: 0.9, opacity: 0.5, z: 1 },
              ];

              const pos = positions[index] || {
                x: 450,
                scale: 0.7,
                opacity: 0.1,
                z: 0,
              };

              return (
                <motion.div
                  key={t.name + index}
                  initial={{ x: pos.x + 200, opacity: 0 }}
                  animate={{ x: pos.x, opacity: pos.opacity, scale: pos.scale }}
                  exit={{ x: pos.x - 200, opacity: 0 }}
                  transition={{ duration: 0.8, ease: "easeInOut" }}
                  style={{ zIndex: pos.z }}
                  className="absolute w-[280px] md:w-[320px] bg-[#111] p-6 rounded-2xl border border-white/5 shadow-xl"
                >
                  {/* Stars */}
                  <div className="flex gap-1 mb-3">
                    {[...Array(5)].map((_, i) => (
                      <span key={i} className="text-[#C5A059] text-sm">★</span>
                    ))}
                  </div>

                  <p className="text-sm text-gray-300 italic mb-4">
                    “{t.feedback}”
                  </p>

                  <div className="border-t border-white/10 pt-3">
                    <h4 className="text-md font-semibold text-[#C5A059]">
                      {t.name}
                    </h4>
                    <p className="text-[10px] text-gray-400 uppercase tracking-widest">
                      {t.role}
                    </p>
                  </div>
                </motion.div>
              );
            })}
          </AnimatePresence>
        </div>

        <div className="flex justify-center mt-10 gap-3">
          {testimonials.map((_, i) => (
            <button
              key={i}
              onClick={() => setCurrent(i)}
              className={`h-2 rounded-full transition-all duration-300 ${
                current === i ? "w-8 bg-[#C5A059]" : "w-2 bg-gray-600"
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
